/* Collection SEO description: Read More / Read Less.
   Collapsed height = first heading + two lines of the first text block, so the block
   always opens on a clean line boundary regardless of viewport width. Expanding animates
   to the full height then releases max-height (so later accordion toggles inside the
   block can grow freely). Collapsing scrolls the block's top back into view so the
   visitor isn't stranded at the bottom of a now-short block. */
(function () {
  function init(root) {
    var body = root.querySelector('[data-lotto-seo-body]');
    var toggle = root.querySelector('[data-lotto-seo-toggle]');
    var label = root.querySelector('[data-lotto-seo-label]');
    if (!body || !toggle || !label) return;

    var open = false;

    function lineHeightOf(el) {
      var lh = parseFloat(window.getComputedStyle(el).lineHeight);
      if (!isNaN(lh)) return lh;
      return parseFloat(window.getComputedStyle(el).fontSize) * 1.4;
    }

    // Collapsed state shows exactly TWO lines of text on every screen size: line 1 in full,
    // line 2 ~55% visible under a short fade so it is obvious the copy continues. Lines are
    // measured as real rendered line boxes (Range.getClientRects), so paragraph breaks or a
    // one-word line can't throw the cut off.
    var PEEK = 0.55;
    function visibleLineCount() {
      return 2;
    }
    function textLineBoxes() {
      var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null);
      var tops = {}; var node;
      while ((node = walker.nextNode())) {
        if (!node.nodeValue.trim()) continue;
        var el = node.parentElement;
        if (!el || el.closest('.lottoxxsheading, h1, h2, h3, h4, h5, h6, .lottoxxssheading, .footer-faq-question')) continue;
        var range = document.createRange(); range.selectNodeContents(node);
        var rects = range.getClientRects();
        for (var i = 0; i < rects.length; i++) {
          if (rects[i].height < 4) continue;
          var key = Math.round(rects[i].top);
          if (!tops[key] || tops[key] < rects[i].height) tops[key] = rects[i].height;
        }
      }
      return Object.keys(tops).map(Number).sort(function (x, y) { return x - y; })
        .map(function (t) { return { top: t, height: tops[t] }; });
    }
    function collapsedHeight() {
      var bodyTop = body.getBoundingClientRect().top;
      var lines = textLineBoxes();
      var n = Math.min(visibleLineCount(), lines.length);
      if (n > 0) {
        var line = lines[n - 1];
        body.style.setProperty('--lotto-seo-fade', Math.round(line.height * 0.9) + 'px');
        return Math.ceil(line.top - bodyTop + line.height * PEEK);
      }
      var heading = body.querySelector('.lottoxxsheading, h1, h2, h3');
      return heading ? Math.ceil(heading.offsetHeight + 48) : 80;
    }

    function headerOffset() {
      var header = document.querySelector('header.header, .section-header, .header-wrapper');
      return header ? header.getBoundingClientRect().height + 16 : 100;
    }

    function collapse(animate) {
      var target = collapsedHeight();
      if (animate) {
        body.style.maxHeight = body.scrollHeight + 'px';
        // force reflow so the transition runs from the current full height
        void body.offsetHeight;
      }
      body.style.maxHeight = target + 'px';
      root.classList.remove('lotto-seo--open');
      toggle.setAttribute('aria-expanded', 'false');
      label.textContent = 'Read More';
      open = false;
    }

    function expand() {
      body.style.maxHeight = body.scrollHeight + 'px';
      root.classList.add('lotto-seo--open');
      toggle.setAttribute('aria-expanded', 'true');
      label.textContent = 'Read Less';
      open = true;
      var release = function (e) {
        if (e && e.target !== body) return;
        if (open) body.style.maxHeight = 'none';
        body.removeEventListener('transitionend', release);
      };
      body.addEventListener('transitionend', release);
      window.setTimeout(release, 450);
    }

    function setup() {
      // Measure with no clamp so scrollHeight is the true content height.
      body.style.maxHeight = 'none';
      var full = body.scrollHeight;
      var target = collapsedHeight();
      if (full <= target + 8) {
        // Nothing to hide: leave it fully shown with no toggle.
        toggle.hidden = true;
        root.classList.add('lotto-seo--open');
        return;
      }
      toggle.hidden = false;
      if (!open) collapse(false);
    }

    toggle.addEventListener('click', function () {
      if (open) {
        collapse(true);
        var top = root.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        expand();
      }
    });

    setup();
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { if (!open) setup(); }, 150);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { if (!open) setup(); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-lotto-seo]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
